import useDiscard from "../../useDiscard";
import useMap from "../../utils/useMap";
import useLayerIdentity from "./validator/useLayerIdentity";
import useQueryOriginalSourceByLayer from "./store/useStoreOriginalSource";


export const useQueryOriginSource = useQueryOriginalSourceByLayer
